/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useCallback, useState, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import clsx from 'clsx';
import './Layer3DataTables.css';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { makeStyles } from '@mui/styles';
import {
	Button, TextField, Typography, Grid, Select, Card,
	CardHeader, CardContent, Divider, Accordion, AccordionSummary,
	AccordionDetails, TextareaAutosize
} from '@mui/material';
import {
	ThemeProvider,
	createMuiTheme,
	MuiThemeProvider,
	withStyles,
} from '@mui/styles/withStyles';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { DataTable, Header, Label } from 'components';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import DataTableRaw from '../../../../../../../../../../../../../components/DataTable/DataTableRaw';
import { SetFormState, GetLayer3MessageMo, GetLayer3MessageMt, GetLayer3Kpis, SetLayer3, GetLayer3DriveTest } from '../../../../../../../../../../../actions/VoiceActions';

const useStyles = makeStyles((theme) => ({
	root: {},
	content: {
		padding: 0,
	},
	inner: {
		minWidth: 700,
	},
	nameCell: {
		display: 'flex',
		alignItems: 'center',
	},
	avatar: {
		height: 42,
		width: 42,
		marginRight: theme.spacing(1),
	},
	actions: {
		padding: theme.spacing(1),
		justifyContent: 'flex-end',
	},
	primaryButton: {
		color: theme.palette.primary.main
	},
	errorButton: {
		color: theme.palette.error.main
	},
	infoButton: {
		color: theme.palette.info.main
	},
	tableRow: {
		'&:hover': {
			cursor: 'pointer'
		}
	}
}));

const Layer3DataTables = (props) => {
	const { className, data, ...rest } = props;
	const classes = useStyles();
	const dispatch = useDispatch();

	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.voiceReducer.formState);
	let updatedData = [];

	const [dataMo, setDataMo] = useState(updatedData);
	const [dataMt, setDataMt] = useState(updatedData);

	// const layer3 = useSelector((state) => {
	// 	setDataMo(state.voiceReducer.layer3.layer3TableMoc === undefined ? updatedData : state.voiceReducer.layer3.layer3TableMoc);
	// 	setDataMt(state.voiceReducer.layer3.layer3TableMtc === undefined ? updatedData : state.voiceReducer.layer3.layer3TableMtc);
	// 	return state.voiceReducer.layer3;
	// });

	const layer3 = useSelector((state) => state.voiceReducer.layer3);
	const layer3MessageMo = useSelector((state) => state.voiceReducer.layer3MessageMo);
	const layer3MessageMt = useSelector((state) => state.voiceReducer.layer3MessageMt);
	const filenameMoc = useSelector((state) => state.voiceReducer.filenameMoc);
	const filenameMtc = useSelector((state) => state.voiceReducer.filenameMtc);
	const failureSide = useSelector((state) => state.voiceReducer.failureSide);
	const initialTimestamp = useSelector((state) => state.voiceReducer.initialTimestamp);

	const userId = useSelector(state => state.session.user.id);

	const [tableSide, setTableSide] = useState('MO');
	const [moPage, setMoPage] = useState(0);
	const [mtPage, setMtPage] = useState(0);

	const _renderActions = (tableMeta) => {
		const { rowData } = tableMeta;

		let upHidden = true;
		let downHidden = true;

		if (rowData[5] === 'UL') {
			upHidden = true;
			downHidden = false;
		} else if (rowData[5] === 'DL') {
			upHidden = false;
			downHidden = true;
		}

		return (
			<>
				<div hidden={upHidden}>
					<ArrowUpwardIcon color="error" />
				</div>
				<div hidden={downHidden}>
					<ArrowDownwardIcon color="primary" />
				</div>
			</>
		);
	};

	const _getTableColumns = () => (
		[
			{
				name: 'id',
				label: 'Id',
				options: {
					display: true,
					filter: false,
					viewColumns: false,
					filterType: 'textField',
				}
			},
			{
				name: 'type',
				label: 'Type',
				options: {
					display: false,
					filter: false,
					viewColumns: false,
					filterType: 'textField',
				}
			},
			{
				name: 'time',
				label: 'Time',
				options: {
					display: true,
					filterType: 'textField',
					customBodyRender: val => {
						const cellStyle = {
							whiteSpace: 'nowrap'
						};
						return (
							<div style={cellStyle}>{val}</div>
						);
					}
				}
			},
			{
				name: 'messageType',
				label: 'Message Type',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'protocol',
				label: 'Protocol',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'direction',
				label: 'Direction',
				options: {
					filter: false,
					sort: false,
					viewColumns: false,
					empty: true,
					customBodyRender: (value, tableMeta, updateValue) => _renderActions(tableMeta)
				}
			}
		]
	);

	const tablesHighlightMo = (moId) => {
		// console.log(rowData);
		const tableBodyMo = document.getElementById('voiceMocDataTable').querySelector('tbody');
		const trs = tableBodyMo.querySelectorAll('tr');

		trs.forEach((tr, index) => {
			const tds = tr.querySelectorAll('td');

			tds.forEach((td, tdIndex) => {
				tr.classList.remove('highlightBackgroundMo');
			});

			tds.forEach((td, tdIndex) => {
				if (td.textContent.trim() === moId.trim()) {
					// console.log(rowData[0]);
					// console.log(td.textContent);
					// console.log(`Conteúdo do TD ${tdIndex} na linha ${index}: ${td.textContent}`);

					tr.classList.add('highlightBackgroundMo');
				}
			});
		});
	};

	const scrollToRowMt = (mtId) => {
		const tableBodyMt = document.getElementById('voiceMtcDataTable').querySelector('tbody');
		const trs = tableBodyMt.querySelectorAll('tr');

		let mtLine = 10000;
		trs.forEach((tr, index) => {
			// 'linha' é a referência para cada elemento <tr>
			// 'index' é o índice do elemento atual

			// Agora você pode fazer algo com cada linha, como acessar os <td> dentro dela
			const tds = tr.querySelectorAll('td');

			tds.forEach((td, tdIndex) => {
				// 'td' é a referência para cada elemento <td> dentro da linha
				// 'tdIndex' é o índice do elemento <td> atual
				if (td.textContent.trim() === mtId) {
					// console.log(td.textContent.trim().substring(0, 19));

					// Faça algo com o elemento <td> aqui, por exemplo, exiba seu conteúdo:
					// console.log(`Conteúdo do TD ${tdIndex} na linha ${index}: ${td.textContent}`);
					// console.log(mtId);
					if (index < mtLine) {
						// console.log(index);
						mtLine = index;
						// tr.classList.add('highlightBackgroundMt');
						// Crie um novo elemento <tr> com a cor de fundo desejada
						// const newTr = document.createElement('tr');
						// tds.forEach((tdw) => {
						// 	const newTd = document.createElement('td');
						// 	newTd.textContent = tdw.textContent;
						// 	// Defina a cor de fundo desejada para cada <td> dentro da nova linha
						// 	newTd.style.backgroundColor = 'yellow'; // Substitua 'yellow' pela cor desejada
						// 	newTr.appendChild(newTd);
						// });

						// // Substitua o <tr> existente pelo novo <tr> na mesma posição
						// tr.parentNode.replaceChild(newTr, tr);
					}
					// return true;
				}
				return true;
			});
		});
		// console.log(mtLine);
		const rowHeight = tableBodyMt.querySelector('tr').clientHeight;
		if (mtLine !== 10000) {
			tableBodyMt.parentNode.parentNode.scrollTop = 0;
			tableBodyMt.parentNode.parentNode.scrollTop = (mtLine * rowHeight);
			// if (mtLine < 200) {
			// 	tableBodyMt.parentNode.parentNode.scrollTop = (mtLine * rowHeight);
			// } else if (mtLine >= 200 && mtLine < 400) {
			// 	tableBodyMt.parentNode.parentNode.scrollTop = (mtLine * rowHeight) + 100;
			// } else if (mtLine >= 400) {
			// 	tableBodyMt.parentNode.parentNode.scrollTop = (mtLine * rowHeight) + 200;
			// }
		}
	};

	const tablesHighlightMt = (mtId) => {
		// console.log(rowData);
		const tableBodyMo = document.getElementById('voiceMtcDataTable').querySelector('tbody');
		const trs = tableBodyMo.querySelectorAll('tr');

		trs.forEach((tr, index) => {
			const tds = tr.querySelectorAll('td');

			tds.forEach((td, tdIndex) => {
				tr.classList.remove('highlightBackgroundMt');
			});

			tds.forEach((td, tdIndex) => {
				if (td.textContent.trim() === mtId.trim()) {
					// console.log(rowData[0]);
					// console.log(td.textContent);
					// console.log(`Conteúdo do TD ${tdIndex} na linha ${index}: ${td.textContent}`);

					tr.classList.add('highlightBackgroundMt');
				}
			});
		});
	};

	const scrollToRowMo = (moId) => {
		const tableBodyMt = document.getElementById('voiceMocDataTable').querySelector('tbody');
		const trs = tableBodyMt.querySelectorAll('tr');

		let moLine = 10000;
		trs.forEach((tr, index) => {
			// 'linha' é a referência para cada elemento <tr>
			// 'index' é o índice do elemento atual

			// Agora você pode fazer algo com cada linha, como acessar os <td> dentro dela
			const tds = tr.querySelectorAll('td');

			tds.forEach((td, tdIndex) => {
				// 'td' é a referência para cada elemento <td> dentro da linha
				// 'tdIndex' é o índice do elemento <td> atual
				if (td.textContent.trim() === moId) {
					// console.log(td.textContent.trim().substring(0, 19));

					// Faça algo com o elemento <td> aqui, por exemplo, exiba seu conteúdo:
					// console.log(`Conteúdo do TD ${tdIndex} na linha ${index}: ${td.textContent}`);

					if (index < moLine) {
						moLine = index;
						// tr.classList.add('highlightBackgroundMo');
						// Crie um novo elemento <tr> com a cor de fundo desejada
						// const newTr = document.createElement('tr');
						// tds.forEach((tdw) => {
						// 	const newTd = document.createElement('td');
						// 	newTd.textContent = tdw.textContent;
						// 	// Defina a cor de fundo desejada para cada <td> dentro da nova linha
						// 	newTd.style.backgroundColor = 'yellow'; // Substitua 'yellow' pela cor desejada
						// 	newTr.appendChild(newTd);
						// });

						// // Substitua o <tr> existente pelo novo <tr> na mesma posição
						// tr.parentNode.replaceChild(newTr, tr);
					}
					return true;
				}
				return true;
			});
		});

		const rowHeight = tableBodyMt.querySelector('tr').clientHeight;
		if (moLine !== 10000) {
			tableBodyMt.parentNode.parentNode.scrollTop = 0;
			tableBodyMt.parentNode.parentNode.scrollTop = (moLine * rowHeight);
			// if (moLine < 200) {
			// 	tableBodyMt.parentNode.parentNode.scrollTop = (moLine * rowHeight);
			// } else if (moLine >= 200 && moLine < 400) {
			// 	tableBodyMt.parentNode.parentNode.scrollTop = (moLine * rowHeight) + 100;
			// } else if (moLine >= 400) {
			// 	tableBodyMt.parentNode.parentNode.scrollTop = (moLine * rowHeight) + 200;
			// }
		}
	};

	const _onRowClick = (rowData, rowMeta) => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				// rowData,
				eventTime: rowData[2].props.children,
				// graphLineTime: rowData[2].props.children
			}
		});

		if (rowData[1] === 'MO') {
			setTableSide('MO');
			dispatch(GetLayer3MessageMo(rowData[0], rowData[2].props.children, 'MO', userId, filenameMtc));
			setDataMt(dataMt);
		} else if (rowData[1] === 'MT') {
			setTableSide('MT');
			dispatch(GetLayer3MessageMt(rowData[0], rowData[2].props.children, 'MT', userId, filenameMoc));
			setDataMo(dataMo);
		}

		dispatch(GetLayer3Kpis(filenameMoc, filenameMtc, failureSide, initialTimestamp, rowData[2].props.children));
		dispatch(GetLayer3DriveTest(userId, formState.values.layer3Kpi || 'rsrp', filenameMoc, filenameMtc, failureSide, initialTimestamp, rowData[2].props.children));
	};

	// const [page, setPage] = useState(0);

	// const _getTableOptions = () => ({
	// 	filterType: 'dropdown',
	// 	// selectableRows: false,
	// 	expandableRows: false, // Try Adding This
	// 	search: false,
	// 	filter: false,
	// 	viewColumns: false,
	// 	onRowClick: (rowData, rowMeta) => _onRowClick(rowData, rowMeta),
	// 	// pagination: false,
	// 	rowsPerPageOptions: [],
	// 	rowsPerPage: [20],
	// 	// page: 2,
	// 	// onTableChange: (action, tableState) => {
	// 	// 	if (action === 'changePage') {
	// 	// 		setPage(tableState.page);
	// 	// 	}
	// 	// }
	// 	setRowProps: (row, index) => {
	// 		if (tableSide === 'MO') {
	// 			if (row[0] === (layer3MessageMo && layer3MessageMo.id)) {
	// 				return {
	// 					style: { background: 'yellow' }
	// 				};
	// 			}

	// 			if (row[0] === (layer3MessageMo && layer3MessageMo.layer3TableMessageOtherSide.id)) {
	// 				console.log(`mt${index}`);
	// 				console.log(`mt${Math.trunc(index / 40)}`);
	// 				return {
	// 					style: { background: 'green' }
	// 				};
	// 			}
	// 		} else {
	// 			if (row[0] === (layer3MessageMt && layer3MessageMt.id)) {
	// 				return {
	// 					style: { background: 'green' }
	// 				};
	// 			}

	// 			if (row[0] === (layer3MessageMt && layer3MessageMt.layer3TableMessageOtherSide.id)) {
	// 				console.log(`mo${index}`);
	// 				console.log(`mo${Math.trunc(index / 40)}`);

	// 				return {
	// 					style: { background: 'yellow' }
	// 				};
	// 			}
	// 		}

	// 		return null;
	// 	}
	// });

	const _getTableOptionsMo = () => ({
		filterType: 'dropdown',
		// selectableRows: false,
		expandableRows: false, // Try Adding This
		search: false,
		filter: false,
		viewColumns: false,
		onRowClick: (rowData, rowMeta) => _onRowClick(rowData, rowMeta),
		// pagination: false,
		rowsPerPageOptions: [],
		rowsPerPage: [40],
		jumpToPage: true,
		textLabels: {
			pagination: {
				jumpToPage: 'Page', // Substitui o texto "Jump to Page"
			},
		},
		page: moPage,
		onTableChange: (action, tableState) => {
			if (action === 'changePage') {
				setMoPage(tableState.page);
			}
		},
		setRowProps: (row, dataIndex, rowIndex) => {
			if (row[0] === (layer3MessageMo && layer3MessageMo.id)) {
				// console.log(`mo${rowIndex}`);
				// console.log(`mo${Math.trunc(rowIndex / 40)}`);
				// setMoPage(Math.trunc(rowIndex / 40));
				return {
					className: 'highlightBackgroundMo'
				};
			}

			if (row[0] === (layer3MessageMt && layer3MessageMt.layer3TableMessageOtherSide.id)) {
				return {
					className: 'highlightBackgroundMt'
				};
			}

			return null;
		}
	});

	const _getTableOptionsMt = () => ({
		filterType: 'dropdown',
		// selectableRows: false,
		expandableRows: false, // Try Adding This
		search: false,
		filter: false,
		viewColumns: false,
		onRowClick: (rowData, rowMeta) => _onRowClick(rowData, rowMeta),
		// pagination: false,
		rowsPerPageOptions: [],
		rowsPerPage: [40],
		jumpToPage: true,
		textLabels: {
			pagination: {
				jumpToPage: 'Page', // Substitui o texto "Jump to Page"
			},
		},
		page: mtPage,
		onTableChange: (action, tableState) => {
			if (action === 'changePage') {
				setMtPage(tableState.page);
			}
		},
		setRowProps: (row, dataIndex, rowIndex) => {
			if (row[0] === (layer3MessageMt && layer3MessageMt.id)) {
				// console.log(`mt${rowIndex}`);
				// console.log(`mt${Math.trunc(rowIndex / 40)}`);
				// setMtPage(Math.trunc(rowIndex / 40));
				return {
					// style: { background: 'blue' }
					className: 'highlightBackgroundMt'
				};
			}

			if (row[0] === (layer3MessageMo && layer3MessageMo.layer3TableMessageOtherSide.id)) {
				return {
					// style: { background: 'blue' }
					className: 'highlightBackgroundMo'
				};
			}

			return null;
		}
	});

	useMemo(() => {
		setDataMo(layer3.layer3TableMoc);
	}, [layer3.layer3TableMoc]);

	useMemo(() => {
		setDataMt(layer3.layer3TableMtc);
	}, [layer3.layer3TableMtc]);

	useMemo(() => {
		if (layer3MessageMo !== undefined) {
			setFormState({
				...formState,
				values: {
					...formState.values,
					layer3MessageMoc: layer3MessageMo.decodedMessage,
					layer3MessageMtc: layer3MessageMo.layer3TableMessageOtherSide && layer3MessageMo.layer3TableMessageOtherSide.decodedMessage
				}
			});

			if (layer3MessageMo.layer3TableMessageOtherSide.id) {
				// tablesHighlightMo(layer3MessageMo.id);
				setTimeout(() => {
					scrollToRowMt(layer3MessageMo.layer3TableMessageOtherSide.id);
				}, 100);
			}
		}
		if (layer3MessageMo && layer3MessageMo.layer3TableMessageOtherSide !== undefined && layer3.layer3TableMtc !== undefined) {
			// console.log(layer3.layer3TableMtc);
			const mtIndex = (layer3.layer3TableMtc).findIndex(x => x.id === layer3MessageMo.layer3TableMessageOtherSide.id);
			// console.log(Math.trunc(mtIndex / 40));
			// console.log(layer3MessageMo.layer3TableMessageOtherSide.id);
			setMtPage(Math.trunc(mtIndex / 40));
		}
	}, [layer3MessageMo]);

	useMemo(() => {
		if (layer3MessageMt !== undefined) {
			setFormState({
				...formState,
				values: {
					...formState.values,
					layer3MessageMtc: layer3MessageMt.decodedMessage,
					layer3MessageMoc: layer3MessageMt.layer3TableMessageOtherSide && layer3MessageMt.layer3TableMessageOtherSide.decodedMessage
				}
			});
			if (layer3MessageMt.layer3TableMessageOtherSide.id) {
				// tablesHighlightMo(layer3MessageMo.id);
				setTimeout(() => {
					scrollToRowMo(layer3MessageMt.layer3TableMessageOtherSide.id);
				}, 100);
			}
		}
		if (layer3MessageMt && layer3MessageMt.layer3TableMessageOtherSide !== undefined && layer3.layer3TableMoc !== undefined) {
			// console.log(layer3.layer3TableMtc);
			const moIndex = (layer3.layer3TableMoc).findIndex(x => x.id === layer3MessageMt.layer3TableMessageOtherSide.id);
			// console.log(Math.trunc(mtIndex / 40));
			// console.log(layer3MessageMo.layer3TableMessageOtherSide.id);
			setMoPage(Math.trunc(moIndex / 40));
		}
	}, [layer3MessageMt]);

	const componentMapping = {
		Skeleton,
	};

	const renderComponentCell = (componentString) => {
		const Component = componentMapping[componentString];
		return Component ? <Component /> : null;
	};

	let columns = '';
	const getColumns = (el) => {
		columns = `${columns}"${el.name}": "Skeleton", `;
	};

	_getTableColumns().forEach(element => getColumns(element));

	columns = columns.slice(0, -2);
	const parsed = JSON.parse(`{${columns}}`);
	const novo = [];

	let i = 1;
	while (i <= 5) {
		novo.push(parsed);
		i++;
	}

	if (data !== []) {
		updatedData = novo.slice(0, 10).map((item) => {
			const updatedItem = {};

			Object.keys(item).forEach((key) => {
				updatedItem[key] = renderComponentCell('Skeleton');
			});

			return updatedItem;
		});
	}

	return (
		<div {...rest} className={clsx(classes.root, className)}>
			{/* New row */}
			<Grid container spacing={4}>
				<Grid item md={12} xs={12}>
					<Card>
						{/* <CardHeader
							title="Messages"
						/>
						<Divider /> */}
						<CardContent>
							<Grid container spacing={4}>
								<Grid item md={6} xs={6}>
									<label>MO</label>
								</Grid>
								<Grid item md={6} xs={6}>
									<label>MT</label>
								</Grid>
							</Grid>
							<Grid container spacing={1}>
								<Grid item md={4} xs={4}>
									<DataTableRaw
										id="voiceMocDataTable"
										title=""
										data={dataMo}
										columns={_getTableColumns()}
										// rowsPerPage={10}
										tableBodyMaxHeight="30vh"
										// tableBodyCellMaxWidth="250"
										options={_getTableOptionsMo()}
										onRowClick={_onRowClick}
										className={classes.tableRow}
									/>
								</Grid>
								<Grid item md={2} xs={2}>
									<Box sx={{ maxHeight: '35vh', overflow: 'auto', paddingTop: '5px' }}>
										<TextField
											id="layer3MessageMoc"
											name="layer3MessageMoc"
											label="Message"
											InputProps={{
												readOnly: true,
												style: { fontSize: '11px' }
											}}
											variant="outlined"
											// error={_hasError('failureSource')}
											fullWidth
											multiline
											// helperText={
											// _hasError('failureSource') ? formState.errors.failureSource[0] : null
											// }
											// onChange={_handleChange}
											value={formState.values.layer3MessageMoc || ''}
										/>
									</Box>
								</Grid>
								<Grid item md={4} xs={4}>
									<DataTableRaw
										id="voiceMtcDataTable"
										title=""
										data={dataMt}
										columns={_getTableColumns()}
										// rowsPerPage={10}
										tableBodyMaxHeight="30vh"
										// tableBodyCellMaxWidth="250"
										options={_getTableOptionsMt()}
										onRowClick={_onRowClick}
										className={classes.tableRow}
									/>
								</Grid>
								<Grid item md={2} xs={2}>
									<Box sx={{ maxHeight: '35vh', overflow: 'auto', paddingTop: '5px' }}>
										<TextField
											id="layer3MessageMtc"
											name="layer3MessageMtc"
											label="Message"
											InputProps={{
												readOnly: true,
												style: { fontSize: '11px' }
											}}
											variant="outlined"
											// error={_hasError('failureSource')}
											fullWidth
											multiline
											// helperText={
											// _hasError('failureSource') ? formState.errors.failureSource[0] : null
											// }
											// onChange={_handleChange}
											value={formState.values.layer3MessageMtc || ''}
										/>
									</Box>
								</Grid>
							</Grid>
						</CardContent>
					</Card>
				</Grid>
			</Grid>
		</div>
	);
};

Layer3DataTables.propTypes = {
	className: PropTypes.string,
	data: PropTypes.array.isRequired,
};

export default Layer3DataTables;
